/**
 * Parse SRT (SubRip) file content into transcript text and start timestamps (seconds).
 * Each cue's start time becomes an entry in transcriptTimestamps; transcript is cues joined with \n\n.
 */
export function parseSrt(srtContent: string): { transcript: string; transcriptTimestamps: number[] } {
  const transcriptParts: string[] = [];
  const transcriptTimestamps: number[] = [];

  // Split by blank lines to get cue blocks (handle \n\n or \r\n\r\n)
  const blocks = srtContent.split(/\n\s*\n/).filter((b) => b.trim());

  for (const block of blocks) {
    const lines = block.trim().split(/\r?\n/).filter((l) => l.trim());
    if (lines.length === 0) continue;

    // First line can be sequence number; second line is usually time range (00:00:00,000 --> 00:00:03,000)
    let timeLineIndex = 0;
    const firstLine = lines[0].trim();
    if (/^\d+$/.test(firstLine)) {
      timeLineIndex = 1;
    }
    const timeLine = lines[timeLineIndex];
    const textLines = lines.slice(timeLineIndex + 1);

    const startSeconds = parseSrtTimeToSeconds(timeLine);
    if (startSeconds !== null) {
      transcriptTimestamps.push(startSeconds);
    }
    const text = textLines.join(' ').trim();
    if (text) {
      transcriptParts.push(text);
    }
  }

  const transcript = transcriptParts.join('\n\n');
  return { transcript, transcriptTimestamps };
}

/** Parse SRT time line "00:00:03,000 --> 00:00:08,000" and return start time in seconds. */
function parseSrtTimeToSeconds(timeLine: string | undefined): number | null {
  if (!timeLine || !timeLine.includes('-->')) return null;
  const startPart = timeLine.split('-->')[0].trim();
  // Format HH:MM:SS,mmm or HH:MM:SS.mmm
  const match = startPart.match(/^(\d{1,2}):(\d{1,2}):(\d{1,2})[,.](\d{1,3})$/);
  if (!match) return null;
  const [, h, m, s, ms] = match;
  return parseInt(h!, 10) * 3600 + parseInt(m!, 10) * 60 + parseInt(s!, 10) + parseInt(ms!, 10) / 1000;
}
